import React from "react";
import MaterialTable from "material-table";
import CircularProgress from "@material-ui/core/CircularProgress";


const UserList = (props) => {
  const [state, setState] = React.useState({
    columns: [
      { title: "Nome", field: "name" },
      {
        title: "E-mail",
        field: "email",
      },
      
    ],
  });
  return (
    <MaterialTable
      title="Usuários Cadastrados"
      columns={state.columns}
      data={props.data}
      editable={{
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              props.onEditUser(newData);
            }, 600);
          }),
        /*onRowDelete: (oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              setState((prevState) => {
                const data = [...prevState.data];
                data.splice(data.indexOf(oldData), 1);
                return { ...prevState, data };
              });
            }, 600);
          }),*/
      }}
      options={{
        actionsColumnIndex: -1,
      }}
      localization={{
        header: {
          actions: "Ações",
        },
      }}
    />
  );
};

export default UserList;
